import styled from 'styled-components'

import {
  Button,
  truncateStyles,
  Box,
  Flex,
  Separator,
  ButtonUnstyled,
  Text,
} from '@sketch/components'
import { Section, AttributeList, AttributeLabel } from '../../components'

export const ExportsSection = styled(Section)`
  padding-bottom: 20px;

  ${Separator} {
    margin: 12px 0;
  }
`
export const AllFormatsSeparator = styled(Separator)``

export const ExportButtonWrapper = styled(Flex)`
  flex: 1;
  justify-content: flex-end;
`

export const DownloadFormatButton = styled(Button)`
  width: 40px;
  height: 24px;
  min-height: 0;
  padding: 0;

  :hover,
  :hover svg {
    color: ${({ theme }) => theme.colors.foreground.secondary.A};
  }

  /* Fixes a strange glitch in Firefox */
  :hover {
    transform: none;
  }

  :disabled svg {
    color: ${({ theme }) => theme.colors.foreground.secondary.D};
  }
`

export const ExportAttributeList = styled(AttributeList)`
  margin: 0 8px;
  padding: 0;
`

export const ExportValue = styled(ButtonUnstyled)`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  border-radius: ${({ theme }) => theme.radii.large};
  padding: 0 12px;

  :hover {
    background-color: ${({ theme }) => theme.colors.state.hover};
  }

  :last-child {
    margin-bottom: 6px; /* stylelint-disable-line scales/space */
  }
`

export const ExportValueLabel = styled(AttributeLabel)`
  min-height: auto;
  flex-basis: 33.3%;
`

export const ExportValueAction = styled.span`
  width: 40px;
  display: flex;
  justify-content: center;
  margin-right: -8px;
`

export const ExportValueSize = styled(Text).attrs({
  textStyle: 'copy.quaternary.standard.D',
})`
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  padding-right: 10px; /* stylelint-disable-line scales/space */
  flex: 1;

  ${truncateStyles};
`

export const SectionStyled = styled(Section)`
  padding-bottom: 12px;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Error = styled(Box).attrs({
  padding: 3,
  borderRadius: 'small',
  backgroundColor: 'rgba(224, 32, 32, 0.05)',
})`
  font-size: 0.8125rem;
  margin: 6px 26px 8px -12px; /* stylelint-disable-line scales/space */

  :first-child {
    margin-top: 0;
  }

  /* && is needed to give more specificity to avoid stylelint warning */
  && ${ExportValue} {
    width: 136px;

    ::after {
      background-image: none;
    }
  }
`

export const ExportAsButton = styled(Button)`
  flex: 1;
`
